import React from 'react';
// import { useSelector } from 'react-redux';
// import { createSelector } from 'reselect';
import PropTypes from 'prop-types';

import { Icon, Div, Col, Row } from '@pinpoint/design-kit';

import { noOp } from 'src/functions';
import { ROUTES } from 'src/config';
import { Rbac } from 'src/containers';
import { Button } from 'src/components';
import CONSTANTS from 'src/store/constants';

// const profileFilter = ({ app }) => app?.profile || {};
// const emailSelector = createSelector([profileFilter], (profile) => profile?.email);
const goBack = {
  list: ROUTES.ONBOARDING_LANDING,
  view: ROUTES.ONBOARDING,
};
/**
 * ButtonNav - Navigation buttons for onboarding list
 *
 * @param {Object} props - components props
 * @param {function} props.goTo - the handler to navigate to the selected button
 * @param {function} props.unset - handler to clear redux state values
 * @param {number|null|undefined} props.onbId - the ID to an onboarding or nothing
 * @param {'list'|'view'} props.mode - which page/mode the nav is in
 * @param {null|undefined|string} props.preMatchInputDistUrl - URL to download a pre-match input distribution
 * @param {undefined|string} props.title - optional page title
 */
function ButtonNav({ goTo, onbId, mode, preMatchInputDistUrl, title, unset }) {
  // const email = useSelector(emailSelector);
  return (
    <Row p={{ b: '0.5rem', t: '1rem', x: '0.5rem' }}>
      <Col size="6" textSize="small" d="flex">
        <Button
          buttonStyle="primary"
          onClick={() => {
            goTo(goBack[mode]);
            if (mode === 'view') {
              unset('onboarding');
              unset('dataset');
            }
          }}
        >
          <Icon name="LongLeft" color="white" m={{ r: '0.5rem' }} size="1rem" />
          BACK
        </Button>
        {mode === 'view' && (
          <>
            <Rbac roles={CONSTANTS.ROLES.slice(0, 4)} fallback={null}>
              <Div data-test="aprv-cl-div">
                <Button
                  buttonStyle="admin"
                  data-tip="View requirements prior to onboarding approval"
                  data-test="aprv-cl-btn"
                >
                  <Icon name="Checklist" color="white" m={{ r: '0.5rem' }} viewBox="0 0 24 24" size="1.25rem" />
                  APPROVAL CHECKLIST
                </Button>
              </Div>
            </Rbac>
            <Rbac roles={CONSTANTS.ROLES.slice(0, 4)}>
              <Div data-test="export-btn-div">
                <Button
                  buttonStyle="admin"
                  data-tip={
                    [null, undefined].includes(preMatchInputDistUrl) ? null : 'Download each record and its inputs'
                  }
                  data-test="export-btn"
                  disabled={[null, undefined].includes(preMatchInputDistUrl)}
                  onClick={() => window.open(preMatchInputDistUrl, '_blank')}
                >
                  <Icon name="Excel" color="white" size="1rem" viewBox="0 0 21 22" m={{ r: '.5rem' }} />
                  SAVE IN EXCEL
                </Button>
              </Div>
            </Rbac>
          </>
        )}
        {mode === 'list' && (
          <Div data-test="inp-dst-div">
            <Button
              buttonStyle="primary"
              data-tip={onbId ? 'View distributions of loss outcomes' : 'Select an Actuarial row'}
              data-test="inp-dst-btn"
              disabled={[null, undefined].includes(onbId)}
              onClick={() => goTo(ROUTES.ONBOARDING_VIEW.replace(':onbId', `${onbId}`))}
            >
              <Icon
                name="DistributionChartEnclosed"
                color="white"
                m={{ r: '0.5rem' }}
                size="16px"
                viewBox="0 0 16 16"
              />
              PRE-MATCH INPUT DISTRIBUTIONS
            </Button>
          </Div>
        )}
      </Col>
      <Col size="6" textAlign="right" justify="flex-end" textColor="navyBlue" textSize="title">
        {mode === 'view' && title}
      </Col>
    </Row>
  );
}

ButtonNav.defaultProps = {
  goTo: noOp,
  unset: noOp,
  preMatchInputDistUrl: null,
  title: null,
  filterOpts: { query: noOp, filter: [], options: {} },
};

ButtonNav.propTypes = {
  title: PropTypes.oneOf([undefined, PropTypes.string]),
  preMatchInputDistUrl: PropTypes.oneOf([null, PropTypes.string]),
  goTo: PropTypes.func,
  unset: PropTypes.func,
  onbId: PropTypes.oneOf([PropTypes.number, null]).isRequired,
  mode: PropTypes.oneOf(['list', 'view']).isRequired,
  filterOpts: PropTypes.shape({
    query: PropTypes.func.isRequired,
    filter: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    options: PropTypes.shape({}).isRequired,
  }),
};

export default React.memo(ButtonNav);
